<template lang="pug">
  div
    h2(class="new-advert-subtitle") Фотографии:
    v-row(no-gutters)
      v-col
        UploadImages(@set-files="setFiles")
</template>

<script>
import UploadImages from '../../common/UploadImages'
export default {
  name: 'Images',
  components: { UploadImages },
  data: () => ({
    files: []
  }),
  watch: {
    files(values) {
      this.$emit('set-image-files', values)
    }
  },
  methods: {
    setFiles(files) {
      this.files = files
    }
  }
}
</script>
